import { HeaderText2TW } from '../../../../tailwindComponents/HeaderTextTW/HeaderTextTW';
import { XMarkIcon } from '@heroicons/react/24/outline';
import React from 'react';

export const WizardTitle = ({ isCorrection, onClose }: { isCorrection?: boolean; onClose: () => void }) => {
  return (
    <div className={'flex flex-row items-center justify-between'}>
      <HeaderText2TW className={'overflow-visible font-medium'}>
        {isCorrection ? `New Correction` : `New Event`}
      </HeaderText2TW>
      <XMarkIcon data-test-id="appointment-title-close-icon" onClick={onClose} className={'h-7 w-7 cursor-pointer'} />
    </div>
  );
};
